import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Card } from 'modules/connect-card/components/connect-hub/PreviewCards';
import { makeStyles } from '@mui/styles';
import { getAccountLogoUrl } from '../utils';
import VideoPlayer from 'components/VideoPlayer';

const useStyles = makeStyles((theme) => ({
  logo: {
    maxWidth: 120,
    maxHeight: 80,
  },
}));

const ConnectPoint = ({ data, cards }) => {
  const theme = useTheme();
  const {
    account,
    collection_title,
    collection_description,
    logo_or_video_url,
    logo_or_video,
  } = data;

  const classes = useStyles();

  const accountLogoUrl = getAccountLogoUrl(account);

  return (
    <Box pb={5} textAlign="center">
      <Container
        maxWidth="sm"
        sx={{ display: 'flex', flexDirection: 'column', my: 4 }}
      >
        <Box p={2}>
          {logo_or_video === 'video' && logo_or_video_url ? (
            <Box mb={2}>
              <VideoPlayer autoplay url={logo_or_video_url} />
            </Box>
          ) : (
            <Box mb={2}>
              <img
                className={classes.logo}
                src={logo_or_video_url || accountLogoUrl}
              />
            </Box>
          )}
          <Typography
            gutterBottom
            variant="h2"
            fontWeight={700}
            color="primary.darker"
          >
            {collection_title}
          </Typography>
          <Typography paragraph fontWeight={500} color="primary.darker">
            {collection_description}
          </Typography>
        </Box>
        <Box mt={4} mb={5}>
          <Grid container spacing={2} rowSpacing={4} justifyContent="center">
            {cards.map((card) => (
              <Grid item key={card.id} xs={12} sm={6}>
                <a
                  target="_blank"
                  href={
                    card.redirect_url || `/connect-cards/${card.card?.hash}`
                  }
                >
                  <Card
                    card={card}
                    color={theme.palette.primary.main}
                    sx={{
                      'cursor': 'pointer',
                      'transition': '0.3s',
                      '&:hover': {
                        boxShadow: '0px 10px 20px 0px rgba(0, 8, 102, 0.1)',
                        transform: 'translateY(-5px)',
                      },
                    }}
                  />
                </a>
                <Typography variant="caption" color="text.secondary">
                  {card.overlay_description}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box mt="auto">
          <Typography variant="caption" color="textSecondary">
            Powered by{' '}
            <Typography
              variant="caption"
              color="primary.darker"
              fontWeight={600}
            >
              Text In Church
            </Typography>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ConnectPoint;
